import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('old.validators', {
    requiredField: 'The field is required',
});
